import AppLabel from "./app-label";

const DraftLabel = ({ className = "" }: { className?: string }) => (
  // `normal-case` overrides AppLabel's default uppercase styling so the pill
  // reads "Draft". `!bg-transparent` strips the gray pill background — the
  // label sits as plain text inline with the surrounding row.
  <AppLabel
    label="Draft"
    className={`normal-case !bg-transparent ${className}`}
  />
);

export default DraftLabel;
